import React from "react";
import { CheckCircle2, Shield } from "lucide-react";

function EventList({ events, selectedEvent, setSelectedEvent }) {
    const isSelected = (event) => selectedEvent && selectedEvent.id === event.id;

    if (!events || events.length === 0) {
        return (
            <div className="text-center py-5">
                <Shield className="mx-auto mb-2 text-muted oct_syslog-shield-icon" />
                <p className="small text-muted mb-0">No keywords configured yet</p>
            </div>
        )
    }

    return (
        <div className="space-y-2 max-h-[400px] overflow-y-auto">
            {events.map((event, index) => (
                <div
                    key={index}
                    onClick={() => setSelectedEvent(event)}
                    className={`oct_keyword-item-v2 ${isSelected(event) ? 'oct_active' : ''}`}
                >
                    <div className="oct_keyword-content">
                        <div className="oct_keyword-number">
                            {index + 1}
                        </div>
                        <span className="oct_keyword-text">
                            {event.name}
                        </span>
                    </div>
                    {isSelected(event) && (
                        <CheckCircle2 className="oct_icon w-5 h-5" />
                    )}
                </div>
            ))}
        </div>
    )
}

export default EventList;
